import { useEffect, useRef } from "react";

export default function PremiumCursor(){
  const ring=useRef(null);
  const dot=useRef(null);

  useEffect(()=>{
    const fine=window.matchMedia("(min-width:768px) and (pointer:fine) and (prefers-reduced-motion: no-preference)").matches;
    if(!fine) return;
    document.documentElement.dataset.premiumCursor="true";
    let x=0,y=0,rx=0,ry=0,frame;
    const move=e=>{x=e.clientX;y=e.clientY;if(dot.current){dot.current.style.transform=`translate3d(${x}px,${y}px,0)`;}}
    const loop=()=>{rx+=(x-rx)*.16;ry+=(y-ry)*.16;if(ring.current)ring.current.style.transform=`translate3d(${rx}px,${ry}px,0)`;frame=requestAnimationFrame(loop);}
    const over=e=>{
      if(!ring.current) return;
      const hit=e.target.closest("a,button,[data-cursor]");
      ring.current.dataset.active=hit?"true":"false";
    };
    window.addEventListener("mousemove",move,{passive:true});
    window.addEventListener("mouseover",over,{passive:true});
    frame=requestAnimationFrame(loop);
    return()=>{delete document.documentElement.dataset.premiumCursor;window.removeEventListener("mousemove",move);window.removeEventListener("mouseover",over);cancelAnimationFrame(frame);};
  },[]);

  return <>
    <span ref={ring} aria-hidden="true" className="premium-cursor-ring fixed left-0 top-0 z-[190] hidden h-9 w-9 -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#d0a26b]/55 pointer-events-none md:block"/>
    <span ref={dot} aria-hidden="true" className="premium-cursor-dot fixed left-0 top-0 z-[191] hidden h-1 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#d0a26b] pointer-events-none md:block"/>
  </>;
}